import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-hot-toast";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import { decryptData } from "../../utils/encrypt"; // ✅ Make sure this path is correct

import {
  
  ACCOUNT_ASSIGNMENT_ENDPOINT,
} from '../../config/api';

function AccountAccessRefresh() {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [refreshedAt, setRefreshedAt] = useState(null);

  let user_id = 0;

  try {
    const encrypted = localStorage.getItem("suyog_user");
    const decrypted = encrypted ? decryptData(encrypted) : null;
    user_id = decrypted?.user_id || 0;
  } catch (err) {
    console.error("Token decryption failed", err);
    toast.error("Session error, please login again.");
  }

  const handleRefresh = async () => {
    if (!user_id) {
      toast.error("Invalid user session");
      return;
    }

    try {
      setLoading(true);
      setStatus("Refreshing...");

      const response = await axios.post(
        ACCOUNT_ASSIGNMENT_ENDPOINT,
        { user_id }
      );

      if (response.data.success) {
        toast.success("✅ Account access refreshed successfully");
        setStatus("✅ Access list updated successfully.");
        setRefreshedAt(new Date().toLocaleString());
      } else {
        toast.error(response.data.message || "❌ Refresh failed");
        setStatus("❌ " + (response.data.message || "Unknown error"));
      }
    } catch (err) {
      console.error(err);
      toast.error("Server error occurred");
      setStatus("❌ Request failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-5">
        <div className="card shadow border-0 rounded-4">
          <div className="card-header bg-primary text-white rounded-top-4">
            <h4 className="mb-0">🔁 Account Access Refresh</h4>
          </div>
          <div className="card-body">
            <p>
              This will re-fetch and update your current account access permissions
              from the backend.
            </p>
            <button
              className="btn btn-success"
              onClick={handleRefresh}
              disabled={loading}
            >
              {loading ? "Refreshing..." : "Refresh Access"}
            </button>

            {status && (
              <div className="alert alert-info mt-4">
                <strong>Status:</strong> {status}
                {refreshedAt && (
                  <div>
                    <strong>Last Refreshed:</strong> {refreshedAt}
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default AccountAccessRefresh;
